export const API_URL = process.env.REACT_APP_API_URL || 'https://server.mends.pro/api';
export const CONTACTS_API_URL = process.env.REACT_APP_CONTACTS_API_URL || API_URL;
